import { render, staticRenderFns } from "./CpyUserAdd.vue?vue&type=template&id=4bcb05d8&scoped=true"
import script from "./CpyUserAdd.vue?vue&type=script&lang=js"
export * from "./CpyUserAdd.vue?vue&type=script&lang=js"
import style0 from "./CpyUserAdd.vue?vue&type=style&index=0&id=4bcb05d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb05d8",
  null
  
)

export default component.exports